import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthState } from '../services/auth.state';
import { LOCAL_ROUTES } from '../../../core/constants/local-routes.constants';

export const authGuard: CanActivateFn = (_, state) => {
  const authState = inject(AuthState);
  const router = inject(Router);

  if (authState.isLoggedIn()) return true;
  return router.createUrlTree([LOCAL_ROUTES.AUTH_LOGIN], {
    queryParams: { redirect: state.url },
  });
};
